import { ReactNode } from 'react';
import SidePanel from 'components/sidePanel/SidePanel';
import { integrationsTabSidePanelId } from './IntegrationsTabs.constants';
import { IntegrationsTabsHeaderContainer } from './IntegrationsTabsHeader.styles';

const IntegrationsTabsHeader = ({
  sidePanelContent,
}: {
  sidePanelContent: ReactNode;
}) => {
  return (
    <IntegrationsTabsHeaderContainer>
      {sidePanelContent && (
        <SidePanel sidePanelId={integrationsTabSidePanelId}>
          {sidePanelContent}
        </SidePanel>
      )}
    </IntegrationsTabsHeaderContainer>
  );
};

export default IntegrationsTabsHeader;
